export enum MessageTriggerStatus {
    Scheduled = "6cf87a55-3fb9-4f28-9540-72a1e141bc13",
    Triggered = "db6048ca-5d24-4168-a7fb-1c611958eaaf",
    Canceled = "e793cbc0-48c5-4d4f-b81b-78d70ddfc848"
}